import { module } from 'stereomodularjs';
import {Swiper, Navigation, Scrollbar } from 'swiper';
// Import navigation module from swiper


export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.swiper = new Swiper(this.el, {
            // Add gap
            spaceBetween: 6,
            modules: [Navigation, Scrollbar],
            scrollbar: {
                el: '.swiper-scrollbar',
                dragSize: 78,
                draggable: true,
            },
            // Add navigation
            navigation: {
                nextEl: '.js-slider-car-next',
                prevEl: '.js-slider-car-prev',
            },
            // 2 items for mobile, 3 for tablet and for desktop
            slidesPerView: 2,
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    // spaceBetween: 20,
                    
                },
                768: {
                    slidesPerView: 3,
                    // spaceBetween: 30,
                }
            },
        
        });
        
       
        
    }
}
 